<template>
  <v-container fluid py-0>
    <v-row>
      <v-col class="py-0">
        <v-container fluid pt-0>
          <v-row justify="end" align="center">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn class="mr-3" v-on="on" icon @click="onReloadList">
                    <v-icon dark>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Refresh List</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-card outlined>
      <v-data-table
        :items="items"
        :headers="headers"
        :loading="$apollo.loading"
      >
        <template v-slot:item.delivered="{ item }">
          <v-simple-checkbox
            v-model="item.delivered"
            :disabled="true"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.opened="{ item }">
          <v-simple-checkbox
            v-model="item.opened"
            :disabled="true"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.sentAt="{ item }">
          {{ item.sentAt | formatDateTime }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small class="mx-0" @click="onView(item)">
            <v-icon small color="cyan">mdi-file-find</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <email-details-dialog
      :show="showDialog"
      @close="showDialog = false"
      v-model="selectedItem"
    ></email-details-dialog>
    <v-row v-if="debug">
      <v-col>
        <code>{{ emails }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
import EmailDetailsDialog from "./EmailDetailsDialog.vue";
const EMAILS_LIST = gql`
  query emailsList($filter: EmailFilterType) {
    emails(filter: $filter) {
      totalCount
      edges {
        node {
          id
          from
          to
          subject
          sentAt
          delivered
          opened
        }
      }
    }
  }
`;
export default {
  components: { EmailDetailsDialog },
  name: "emails-list",

  props: {
    itineraryId: {
      type: String,
      default: () => undefined,
    },
    clientId: {
      type: String,
      default: () => undefined,
    },
    agentId: {
      type: String,
      default: () => undefined,
    },
  },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "From",
          value: "from",
          name: "from",
        },
        {
          text: "To",
          value: "to",
          name: "to",
        },
        {
          text: "Subject",
          value: "subject",
          name: "subject",
        },
        {
          text: "Sent",
          value: "sentAt",
          name: "sentAt",
        },
        {
          text: "Delivered",
          value: "delivered",
          name: "delivered",
        },
        {
          text: "Opened",
          value: "opened",
          name: "opened",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
      selectedItem: null,
      showDialog: false,
    };
  },

  computed: {
    items() {
      return this.emails && this.emails.edges
        ? this.emails.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onReloadList() {
      this.$apollo.queries.emails.refetch();
    },
    onView(item) {
      this.selectedItem = { ...item };
      this.showDialog = true;
      console.log("showing :", item);
    },
  },

  apollo: {
    emails: {
      query: EMAILS_LIST,
      variables() {
        return {
          filter: {
            itineraryId: this.itineraryId,
            clientId: this.clientId,
            agentId: this.agentId,
          },
        };
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/EmailsList.vue